<div class="ap-autocomplete-option__label" [innerHTML]="matchBold(label, searchTerm())" data-testid="autocomplete-option-label"></div>
@for (description of descriptions; track description) {
    <div
        class="ap-autocomplete-option__description"
        [innerHTML]="matchBold(description, searchTerm())"
        data-testid="autocomplete-option-description"
    ></div>
}
